import PropTypes from "prop-types"
import React from "react"

import { showHolidayRma, holidayRmaDates } from "helpers/holiday"

import { MsgWrap } from "./components"

const HolidayMsg = ({ style }) => (
  <>
    {showHolidayRma() && (
      <MsgWrap {...style}>
        Please note: In order to focus on customer{" "}
        {sl.config.guaranteed_holiday} orders, we will pause processing repairs
        between {holidayRmaDates.start} and {holidayRmaDates.end}.
      </MsgWrap>
    )}
  </>
)

HolidayMsg.propTypes = {
  style: PropTypes.object,
}

export default HolidayMsg
